import TermsAndConditionsContent from '@/components/App/TermsAndConditionsContent';
import React from 'react';
import { Helmet } from 'react-helmet';

type Props = {};

export default function TermsAndConditionsPage({}: Props) {
  return (
    <section className="container mt-50 mb-20">
      <Helmet>
        <title>NTA Terms and Conditions for Online Reservations for Hotels and Activities</title>
      </Helmet>
      <div className="text-20 fw-500  text-blue-1 mb-20 text-center">NTA Terms and Conditions for Online Reservations for Hotels and Activities</div>
      <TermsAndConditionsContent />
    </section>
  );
}
